import { useEffect, useState } from "react";
import { Spin } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import { useBannerMobileContext } from "../../context/BannerMobileContext/BannerMobileContext";
import { BannerMobileListItem } from "../../context/BannerMobileContext/constants";
import {
	Container,
	HeaderComponent,
	BannerItem,
	BannerLabel,
	SwapButton,
	ActionButtonComponent,
} from "./styles";
import MainButtonComponent from "../../components/MainButtonComponent";


const OrderBannerMobile = () => {
	const { getBannerMobileList, bannerMobileList, operationStatus, updateBannerMobileOrders } = useBannerMobileContext();
	const [orderedList, setOrderedList] = useState<BannerMobileListItem[]>([]);

	useEffect(() => {
		getBannerMobileList();
	}, []);

	useEffect(() => {
		if (bannerMobileList && bannerMobileList.length > 0) {
			const sorted = [...bannerMobileList].sort(
				(a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
			);
			setOrderedList(sorted);
		}
	}, [bannerMobileList]);

	const handleSwap = (index: number) => {
		if (index >= orderedList.length - 1) return;
		const newList = [...orderedList];
		const temp = newList[index];
		newList[index] = newList[index + 1];
		newList[index + 1] = temp;
		setOrderedList(newList);
	};

	const handleSave = async () => {
		updateBannerMobileOrders(orderedList);
	};

	return (
		<Container>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<HeaderComponent>Mobil Banner Sıralama</HeaderComponent>
				{orderedList.map((banner, index) => (
					<BannerItem key={banner.bannerId}>
						<BannerLabel>
							{index + 1} - {banner.firstHeader}
						</BannerLabel>
						<SwapButton
							onClick={() => handleSwap(index)}
							disabled={index >= orderedList.length - 1}
							title="Aşağıdaki mobil banner ile değiştir"
						>
							<SwapOutlined />
						</SwapButton>
					</BannerItem>
				))}
				<ActionButtonComponent>
					<MainButtonComponent type="default" onClick={handleSave} loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
						Kaydet
					</MainButtonComponent>
				</ActionButtonComponent>
			</Spin>
		</Container>
	);
};

export default OrderBannerMobile;
